import { useContext } from 'react';

import { useDialogTabTrap, useModalPortal } from 'App/hooks';
import { LanguageContext } from 'App/Providers/games';

import ageBadge from '../../../assets/landing_age-confirmation-modal_badge.png';
import polyglot from '../../../localization';
import FullscreenModalFrame from '../FullscreenModalFrame';


import './styles.scss';

/**
 * Full-viewport age confirmation dialog (Figma Overlay+Cookies).
 *
 * @param {() => void} onYes - Callback function to handle the "Yes" button click
 * @param {() => void} onNo - Callback function to handle the "No" button click
 * @param {string} [className]
 */
export default function AgeConfirmationModal({ onYes, onNo, className = '' }) {
    const { locale } = useContext(LanguageContext);

    const { portalEl, dialogRef } = useModalPortal({
        rootClassName: 'age-confirmation-modal',
        bodyLockClass: 'age-confirmation-modal-is-open',
        portalMarker: 'age-confirmation',
    });

    useDialogTabTrap(dialogRef);

    return (
        <FullscreenModalFrame
            portalEl={portalEl}
            dialogRef={dialogRef}
            layerClassName={`age-confirmation-modal__layer ${className}`}
            backdropClassName='age-confirmation-modal__backdrop'
            dialogClassName='age-confirmation-modal__dialog'
            dialogProps={{
                'role': 'dialog',
                'aria-modal': true,
                'aria-labelledby': 'age-confirmation-modal-title',
                'tabIndex': -1,
            }}>
            <div className='age-confirmation-modal__row'>
                <img
                    className='age-confirmation-modal__badge'
                    src={ageBadge}
                    alt={polyglot.t(`${locale}.ageConfirmation.badgeAlt`)}
                    width={38}
                    height={38}
                />

                <p
                    className='age-confirmation-modal__title'
                    id='age-confirmation-modal-title'>
                    {polyglot.t(`${locale}.ageConfirmation.title`)}
                </p>
            </div>

            <div className='age-confirmation-modal__actions'>
                <button
                    type='button'
                    className='age-confirmation-modal__btn age-confirmation-modal__btn--secondary'
                    onClick={onNo}>
                    {polyglot.t(`${locale}.ageConfirmation.no`)}
                </button>

                <button
                    type='button'
                    className='age-confirmation-modal__btn age-confirmation-modal__btn--primary'
                    onClick={onYes}>
                    {polyglot.t(`${locale}.ageConfirmation.yes`)}
                </button>
            </div>
        </FullscreenModalFrame>
    );
}
